'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

export interface IntentPrefetchProps {
  prefetch: false;
  onMouseEnter: () => void;
  onFocus: () => void;
  onTouchStart: () => void;
}

// WHY: префетч по видимости на динамических страницах — это некэшируемый SSR на каждую ссылку в кадре; по наведению,
// фокусу или касанию маршрут тянется только тот, куда реально идут
export function useIntentPrefetch(): (href: string) => IntentPrefetchProps {
  const router = useRouter();
  return useCallback(
    (href: string) => {
      const prefetch = () => {
        if (href.startsWith('/')) router.prefetch(href);
      };
      return { prefetch: false, onMouseEnter: prefetch, onFocus: prefetch, onTouchStart: prefetch };
    },
    [router],
  );
}
